<div class="kpi-wrapper">

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-left">
      <div class="header-icon">
        <i class="fas fa-chart-line"></i>
      </div>
      <div>
        <h1 class="page-title">Manager Portal</h1>
        <p class="page-subtitle">Monthly KPI Management</p>
      </div>
    </div>
  </div>

  <!-- Tab Group -->
  <mat-tab-group class="kpi-tab-group" [(selectedIndex)]="activeTabIndex" animationDuration="300ms">

    <!-- ===================== TAB 1: Monthly KPI Form ===================== -->
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="fas fa-clipboard-list me-2"></i> Monthly KPI Form
      </ng-template>

      <div class="tab-content-wrapper">

        <!-- Month Badge + Employee Selector -->
        <div class="selector-row">

          <div class="selector-group">
            <label class="selector-label">
              <i class="fas fa-calendar-alt me-1"></i> Month
            </label>
            <div class="month-badge">
              <i class="fas fa-calendar-check me-2"></i>
              <span>{{ currentMonthLabel }}</span>
            </div>
          </div>

          <div class="selector-group">
            <label class="selector-label">
              <i class="fas fa-user me-1"></i> Select Employee
            </label>
            <ng-select [items]="employeeDropdown" bindLabel="employee_name" [searchable]="true" [clearable]="true"
              [loading]="loadingEmployees" loadingText="Loading employees..." placeholder="Search Employee here"
              [(ngModel)]="selectedFormEmployee" (ngModelChange)="onFormEmployeeChange()" class="kpi-ng-select">
            </ng-select>
          </div>

        </div>

        <!-- KPI Data Loader -->
        <div class="loader-wrapper" *ngIf="loadingKpiData">
          <div class="loader"></div>
          <p class="loader-text">Loading KPI data...</p>
        </div>
        <div class="empty-state" *ngIf="!loadingKpiData && !selectedFormEmployee">
          <div class="empty-icon">
            <i class="fas fa-user"></i>
          </div>
          <h4>Select an Employee</h4>
          <p>Please select an employee from the dropdown to view and assign KPI parameters</p>
        </div>

        <!-- KPI Table -->
        <div class="table-container" *ngIf="!loadingKpiData && selectedFormEmployee">
          <table class="kpi-table">
            <thead>
              <tr>
                <th class="col-no">No</th>
                <th class="col-param">Parameters</th>
                <th class="col-select text-center">KPI Parameter<br><span class="th-sub">(Select)</span></th>
                <th class="col-last text-center">Last Month<br>Value</th>
                <th class="col-target text-center">Target</th>
                <th class="col-manager text-center">Manager<br>Proposed Mark</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let param of kpiParameters" [class.coming-soon-row]="param.isComingSoon"
                [class.selected-row]="param.isSelected && !param.isComingSoon">

                <td class="col-no">
                  <span class="row-number" [class.faded]="param.isComingSoon">{{ param.no }}</span>
                </td>

                <td class="col-param">
                  <span class="param-name" [class.faded]="param.isComingSoon">{{ param.parameter }}</span>
                  <span *ngIf="param.isComingSoon" class="coming-soon-badge">
                    <i class="fas fa-clock me-1"></i>Coming Soon
                  </span>
                </td>

                <td class="col-select text-center">
                  <div class="checkbox-wrapper" [class.disabled-check]="param.isComingSoon">
                    <input type="checkbox" class="kpi-checkbox" [checked]="param.isSelected"
                      [disabled]="param.isComingSoon" (change)="onCheckboxChange(param)">
                  </div>
                </td>

                <td class="col-last text-center">
                  <span class="last-month-value" [class.faded]="param.isComingSoon">
                    <ng-container *ngIf="param.lastMonthValue !== null">
                      {{ param.lastMonthValue | number:'1.0-2' }}<span *ngIf="param.no === 6 || param.no === 9">%</span>
                    </ng-container>
                    <ng-container *ngIf="param.lastMonthValue === null">&#8212;</ng-container>
                  </span>
                </td>

                <!-- Target -->
                <td class="col-target text-center">
                  <!-- Rows 6 and 9: fixed value, no edit -->
                  <ng-container *ngIf="param.no === 6 || param.no === 9">
                    <span class="report-value">{{ param.target }}%</span>
                  </ng-container>
                  <!-- All other rows: normal editable -->
                  <ng-container *ngIf="param.no !== 6 && param.no !== 9 && !param.isComingSoon && param.hasTarget">
                    <input *ngIf="param.isSelected" type="number" class="target-input" [value]="param.target"
                      (input)="onTargetInput(param, $event)" placeholder="Target" min="0">
                    <span *ngIf="!param.isSelected && param.target !== null" class="report-value">{{ param.target
                      }}</span>
                    <span *ngIf="!param.isSelected && param.target === null" class="empty-cell">&#8212;</span>
                  </ng-container>
                  <span *ngIf="param.no !== 6 && param.no !== 9 && !param.isComingSoon && !param.hasTarget"
                    class="empty-cell">&#8212;</span>
                  <span *ngIf="param.isComingSoon" class="faded">&#8212;</span>
                </td>

                <!-- Manager Proposed Mark -->
                <!-- Manager Proposed Mark -->
                <td class="col-manager text-center">
                  <ng-container
                    *ngIf="!param.isComingSoon && (param.hasTarget || param.no === 1 || param.no === 2 || param.no === 3 || param.no === 4 || param.no === 5)">
                    <input *ngIf="param.isSelected" type="number" class="manager-input"
                      [value]="param.managerProposedMark" (input)="onManagerMarkInput(param, $event)"
                      placeholder="e.g. -5">
                    <span *ngIf="!param.isSelected && param.managerProposedMark !== null" class="report-value">{{
                      param.managerProposedMark }}</span>
                    <span *ngIf="!param.isSelected && param.managerProposedMark === null"
                      class="empty-cell">&#8212;</span>
                  </ng-container>
                  <span
                    *ngIf="!param.isComingSoon && !param.hasTarget && param.no !== 1 && param.no !== 2 && param.no !== 3 && param.no !== 4 && param.no !== 5"
                    class="empty-cell">&#8212;</span>
                  <span *ngIf="param.isComingSoon" class="faded">&#8212;</span>
                </td>


              </tr>
            </tbody>
          </table>
        </div>

        <!-- Submit Button -->
        <div class="form-actions" *ngIf="!loadingKpiData && selectedFormEmployee">
          <button class="btn-submit" (click)="submitForm()" [disabled]="isSubmitting || !isFormValid()">
            <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
            <i class="fas fa-paper-plane me-2" *ngIf="!isSubmitting"></i>
            <span>{{ isSubmitting ? 'Submitting...' : 'Submit KPI Form' }}</span>
          </button>
        </div>

      </div>
    </mat-tab>

    <!-- ===================== TAB 2: KPI Report ===================== -->
    <mat-tab>
      <ng-template mat-tab-label>
        <i class="fas fa-file-alt me-2"></i> KPI Report
      </ng-template>

      <div class="tab-content-wrapper">

        <!-- Selectors Row -->
        <div class="selector-row report-selectors">

          <div class="selector-group">
            <label class="selector-label">
              <i class="fas fa-calendar me-1"></i> Select Month
            </label>
            <input type="month" class="form-control kpi-select" [(ngModel)]="selectedReportMonth"
              (ngModelChange)="onReportSelectionChange()" style="background-color: transparent;">
          </div>

          <div class="selector-group">
            <label class="selector-label">
              <i class="fas fa-user me-1"></i> Select Employee
            </label>
            <ng-select [items]="employeeDropdown" bindLabel="employee_name" [searchable]="true" [clearable]="true"
              [loading]="loadingEmployees" loadingText="Loading employees..." placeholder="Search Employee here"
              [(ngModel)]="selectedReportEmployee" (ngModelChange)="onReportSelectionChange()" class="kpi-ng-select">
            </ng-select>
          </div>

          <!-- View Report Button — same row as selectors -->
          <div class="selector-group selector-group-btn">
            <label class="selector-label">&nbsp;</label>
            <button class="btn-view-report" (click)="loadReport()"
              [disabled]="loadingReport || !selectedReportEmployee || !selectedReportMonth">
              <i class="fas fa-spinner fa-spin me-2" *ngIf="loadingReport"></i>
              <i class="fas fa-search me-2" *ngIf="!loadingReport"></i>
              <span>{{ loadingReport ? 'Loading...' : 'View Report' }}</span>
            </button>
          </div>

        </div>

        <!-- Loader -->
        <div class="loader-wrapper" *ngIf="loadingReport">
          <div class="loader"></div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!showReport && !loadingReport">
          <div class="empty-icon">
            <i class="fas fa-file-alt"></i>
          </div>
          <h4>No Report Available</h4>
          <p>Please select an employee and month, then click View Report</p>
        </div>

        <!-- Report Content -->
        <div class="report-content" *ngIf="showReport && !loadingReport">

          <!-- Report Header -->
          <div class="report-header">
            <h2 class="report-emp-name">{{ getSelectedEmployeeName() }}</h2>
            <p class="report-period">Monthly KPI &#8212; {{ getSelectedMonthLabel() }}</p>
          </div>

          <!-- No data state inside report -->
          <div class="empty-state" *ngIf="reportData.length === 0">
            <div class="empty-icon"><i class="fas fa-inbox"></i></div>
            <h4>No KPI parameters found</h4>
            <p>No targets have been assigned for this employee and month</p>
          </div>

          <!-- Report Table -->
          <div class="table-container" *ngIf="reportData.length > 0">
            <table class="kpi-table report-table">
              <thead>
                <tr>
                  <!-- <th class="col-no">No.</th> -->
                  <th class="col-param">KPI Parameter</th>
                  <th class="col-target text-center">Target</th>
                  <th class="col-achieved text-center">Achieved</th>
                  <th class="col-manager text-center">Manager's Score</th>
                  <th class="col-score text-center">Score</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of reportData">
                  <!-- <td class="col-no"><span class="row-number">{{ row.no }}</span></td> -->
                  <td class="col-param"><span class="param-name">{{ row.parameter }}</span></td>
                  <td class="text-center"><span class="report-value">{{ row.target }}</span></td>
                  <td class="text-center"><span class="report-value achieved-value">{{ row.achieved }}</span></td>
                  <td class="text-center">
                    <span class="manager-score" [ngClass]="getManagerScoreClass(row.managersScore)">{{ row.managersScore
                      }}</span>
                  </td>
                  <td class="text-center">
                    <span class="score-badge" [ngClass]="getScoreClass(row.score)">{{ row.score }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Incentive Deduction -->
          <!-- <div class="incentive-block">
            <span class="incentive-label">INCENTIVE DEDUCTION = AED</span>
            <span class="incentive-value" [class.zero]="incentiveDeduction === 0">{{ incentiveDeduction }}</span>
          </div> -->

        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>